/*
  To insert Appcues, we follow the second example of inserting a plugin from the README.
  However, we are faced with the case where the tag that is inserted creates a second tag,
  where the script is actually located.
  So it happened that functions were undefined at the time you called them.
  As a solution, a Promise is created to resolve when the second script tag is inserted in the DOM.
  The way to validate whether the second script tag has already been instantiated is by creating
  an observer object, which when inserted into the DOM with the tag's characteristics, the Promise
  is resolved and thus I have access to the functions.
*/

const APP_ID = '39569';
const APP_SOURCE = `//fast.appcues.com/${APP_ID}.js`;

export const GUEST_VALUE = 999999999999999;

export function insertAppcues({
  email,
  name,
  created_at,
  user_id,
  master,
  payment_kind,
  user_group,
  user_admin,
  account_id,
  account_name,
  account_user_group,
  role,
  pod,
  path_url,
  universe_id,
  universe_name,
  user_type,
  studio,
}) {
  window.Appcues.identify(user_id, {
    email,
    name,
    created_at,
    user_id,
    master,
    payment_kind,
    user_group,
    user_admin,
    user_type,
    account_id,
    account_name,
    account_user_group,
    role,
    pod,
    path_url,
    universe_id,
    universe_name,
    studio,
  });
}

export function insertAppcuesPlugin(userData) {
  /* eslint-disable */
  (function() {    
    const scriptList = document.getElementsByTagName('script');

    if (!isThereAppcuesTag(scriptList)) {
      const [firstScript] = scriptList;
      const appcuesScript = document.createElement('script');
      appcuesScript.id = APP_SOURCE;
      appcuesScript.async = true;
      appcuesScript.defer = true;
      appcuesScript.src = APP_SOURCE;
      firstScript.parentNode.insertBefore(appcuesScript, firstScript);

      window.AppcuesSettings = {
        enableURLDetection: true,
      };
    }
  }());

  const appcues = appcuesPromisse();
  appcues.then(() => {
    insertAppcues(userData);
  });
}

function isThereAppcuesTag(scriptList) {
  return scriptList.namedItem(APP_SOURCE);
}

function appcuesPromisse() {
  return new Promise((resolve, reject) => {
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if(mutation.type === 'childList' && mutation.addedNodes.length > 0) {
          const [addedNode,] = mutation.addedNodes;

          if(isAppcuesScriptTag(addedNode)) {
            resolve();
          }
        }
      });
    });

    observer.observe(document.documentElement, {
      childList: true,
      subtree: true,
    })
  });
}

function isAppcuesScriptTag(addedNode) {
  const regex = /sha256-/u;

  return addedNode.tagName === 'SCRIPT'
  && addedNode.crossOrigin === 'anonymous'
  && addedNode.integrity.match(regex);
}